import styled from 'styled-components';

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-top: ${({ $standalone }) => ($standalone ? '24px' : '0')};
`;

export const Label = styled.label`
  font-family: 'Montserrat', sans-serif;
  font-size: 12px;
  color: #6C6C6C;
  margin-bottom: 4px;
`;

export const FieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 38px;
  padding-bottom: 8px;
  padding-right: ${({ $disabled }) => ($disabled ? '28px' : '0')};
  border-bottom: 1px solid ${({ $hasError }) => ($hasError ? '#F89393' : '#4F4F4F')};
  position: relative;

  &:focus-within {
    border-bottom-color: ${({ $hasError }) => ($hasError ? '#F89393' : '#00003C')};
  }

  ${({ $disabled }) => $disabled && `
    &::after {
      content: '';
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 16px;
      height: 16px;
      background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'%3e%3crect x='2.5' y='7.5' width='11' height='7' rx='1.5' stroke='%2300003C' stroke-width='1.2'/%3e%3cpath d='M5 7.5V5a3 3 0 016 0v2.5' stroke='%2300003C' stroke-width='1.2' stroke-linecap='round'/%3e%3ccircle cx='8' cy='11' r='1.2' fill='%2300003C'/%3e%3c/svg%3e");
      background-size: contain;
      background-repeat: no-repeat;
    }
  `}
`;

export const FloatingLabel = styled.span`
  font-family: 'Montserrat', sans-serif;
  font-size: 12px;
  font-weight: 400;
  color: #4F4F4F;
  letter-spacing: -0.8px;
  line-height: 1;
  margin-bottom: 4px;
`;

export const MaskedInputStyle = styled.div`
  input {
    border: none;
    font-family: 'Montserrat', sans-serif;
    font-size: 14px;
    font-weight: ${({ $hasValue }) => ($hasValue ? '600' : '400')};
    color: #4F4F4F;
    letter-spacing: -0.8px;
    outline: none;
    background: transparent;
    width: 100%;
    padding: 0;
    line-height: 1;
    height: auto;
    box-shadow: none;
    border-radius: 0;

    &::placeholder {
      color: #4F4F4F;
      font-weight: 400;
    }
  }
`;

export const ErrorMessage = styled.span`
  font-family: 'Montserrat', sans-serif;
  color: #F89393;
  font-size: 12px;
  margin-top: 4px;
`;
